import {
  CreatePushSubscriptionRequest,
  CreatePushSubscriptionResponse,
  GetPushSubscriptionRequest,
  GetPushSubscriptionResponse,
} from '@inplay/models';
import { getEnvironmentVariable } from '../helper/config';
import axiosClient from '../utils/apiClient';
import apiClient from '../utils/apiClient';
import { isApiError } from '../utils/helper';
import { EnvVariables, StorageKey } from '../utils/helper.type';

export class PushNotificationService {
  private baseApi: string;

  constructor() {
    const baseUrl: string | undefined = axiosClient.defaults.baseURL;

    if (!baseUrl) {
      throw new Error('baseURL is not defined in axiosClient.');
    }

    this.baseApi = baseUrl;
  }

  public async createPushSubscription(
    payload: CreatePushSubscriptionRequest,
  ): Promise<CreatePushSubscriptionResponse> {
    try {
      console.log(`[ENTRY][PushNotificationService][createPushSubscription]`, {
        ...payload,
      });

      const createPushSubscriptionApiResource: string = getEnvironmentVariable(
        EnvVariables.REACT_APP_NOTIFICATION_SUBSCRIPTION_RESOURCE,
      );

      const createPushSubscriptionApiEndpoint: string = `${this.baseApi}${createPushSubscriptionApiResource}`;

      const createPushSubscriptionApiResponse: CreatePushSubscriptionResponse =
        (
          await apiClient.post(createPushSubscriptionApiEndpoint, {
            ...payload,
          })
        ).data;

      console.log(`[EXIT][PushNotificationService][createPushSubscription]`, {
        createPushSubscriptionApiResponse,
      });

      // Set Local Storage to contain device ID result
      localStorage.setItem(
        StorageKey.DEVICE_ID,
        createPushSubscriptionApiResponse.pushSubscription.deviceId,
      );

      return createPushSubscriptionApiResponse;
    } catch (error: unknown) {
      console.error(
        `[PushNotificationService][createPushSubscription][ERROR]`,
        {
          error,
        },
      );
      if (isApiError(error)) {
        throw error;
      }
      throw error;
    }
  }

  public async getPushSubscription(
    payload: GetPushSubscriptionRequest,
  ): Promise<GetPushSubscriptionResponse> {
    try {
      console.log(`[ENTRY][PushNotificationService][getPushSubscription]`, {
        ...payload,
      });

      const getPushSubscriptionApiResource: string = getEnvironmentVariable(
        EnvVariables.REACT_APP_NOTIFICATION_SUBSCRIPTION_RESOURCE,
      );

      const queryParams = new URLSearchParams(
        Object.entries(payload)
          .filter(([, v]) => v !== undefined && v !== null)
          .map(([k, v]) => [k, String(v)]),
      );

      const getPushSubscriptionApiEndpoint: string = `${this.baseApi}${getPushSubscriptionApiResource}?${queryParams.toString()}`;

      const getPushSubscriptionApiResponse: GetPushSubscriptionResponse = (
        await apiClient.get(getPushSubscriptionApiEndpoint)
      ).data;

      console.log(`[EXIT][PushNotificationService][createPushSubscription]`, {
        getPushSubscriptionApiResponse,
      });
      return getPushSubscriptionApiResponse;
    } catch (error: unknown) {
      console.error(
        `[PushNotificationService][createPushSubscription][ERROR]`,
        {
          error,
        },
      );
      if (isApiError(error)) {
        throw error;
      }
      throw error;
    }
  }
}
